import { Box, Typography } from "@mui/material";
import { Link } from "@tanstack/react-router";
import { ArrowRight2 } from "iconsax-react";
import { useTranslation } from "react-i18next";

import { CreateShopProgressBar, CreateShopWizardNav } from "@/components/Molecules";
import { formatPersianNumber } from "@/lib/format/persian";
import type { CreateShopMobileShellProps } from "./CreateShopMobileShell.types";
import * as styles from "./CreateShopMobileShell.styles";

export function CreateShopMobileShell({
  stepIndex,
  stepName,
  progressPercent,
  children,
  ...navProps
}: CreateShopMobileShellProps) {
  const { t } = useTranslation("shops");

  return (
    <Box sx={styles.root}>
      <Box sx={styles.header}>
        <Box sx={styles.headerRow}>
          <Link to="/" style={{ textDecoration: "none" }}>
            <Box component="span" sx={styles.back}>
              <ArrowRight2 size={20} variant="Linear" />
            </Box>
          </Link>
          <Box sx={styles.grow}>
            <Typography sx={styles.title}>{t("title")}</Typography>
            <Typography sx={styles.meta}>
              {t("create.mobileStep", {
                step: formatPersianNumber(stepIndex + 1),
                name: stepName,
              })}
            </Typography>
          </Box>
        </Box>
        <CreateShopProgressBar percent={progressPercent} />
      </Box>

      <Box sx={styles.content}>{children}</Box>

      <Box sx={styles.footer}>
        <CreateShopWizardNav {...navProps} mobile />
      </Box>
    </Box>
  );
}
